/* eslint-disable no-var */
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

declare global {
  interface Window {
    _wct?: any; // Change `any` to the type of `_wct`, if you know it
  }
}

interface Props {
  metaDescription: string;
  title: string;
  lang: string;
  meta: any;
}

function SEO({ metaDescription, lang, meta, title }: Props): JSX.Element {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: 'viewport',
          content:
            'minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no',
        },
      ].concat(meta)}
    >
      <script type="text/javascript">
        {typeof window !== 'undefined'
          ? (function(w, c, t, u) {
              w._wct = w._wct || {};
              w._wct = u;
              var s = c.createElement(t);
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore: Unreachable code error
              s.type = 'text/javascript';
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore: Unreachable code error
              s.async = true;
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore: Unreachable code error
              s.src = 'https://wct-2.com/wct.js?type=session';
              var r = c.getElementsByTagName(t)[0];
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore: Unreachable code error
              r.parentNode.insertBefore(s, r);
            })(window, document, 'script', {
              uid: 'MXcDDy',
              proxy: 'https://wct-2.com',
              auto_tagging: true,
              click_id_placeholder: '{clickid}',
            })
          : null}
      </script>
      <link
        rel="preload"
        href="https://wct-2.com/wct.js?type=session"
        as="script"
      ></link>
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: `no`,
  meta: [],
  metaDescription: ``,
};

SEO.propTypes = {
  metaDescription: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
